module.exports = __webpack_public_path__ + "img/5b_Users.3bab97de.png";